<template>
  <v-layout
    justify-center
    :pt-4="$vuetify.breakpoint.mdAndUp"
  >
    <v-flex
      xs10
      sm8
    >
      <p class="required-block required-block_left mb-2">
        {{ $t('label.required_fields') }}
      </p>
      <h2 class="display-3 display-3_dark mb-1">
        {{ $t('outside_family.fills_person_data.title') }}
      </h2>
      <p
        class="subtitle"
        :class="[mobileScreen ? 'mb-0' : 'f-1']"
      >
        {{ $t('outside_family.fills_person_data.subtitle') }}
      </p>
      <form class="person-data-form">
        <v-text-field
          v-model.trim="first_name"
          v-validate="validationRules.get('first_name')"
          class="required-field"
          :error-messages="errors.collect('first_name')"
          :label="$t('label.first_name')"
          :data-vv-as="$t('label.first_name')"
          data-vv-name="first_name"
          required
        />
        <v-text-field
          v-model.trim="last_name"
          v-validate="validationRules.get('last_name')"
          class="required-field"
          :error-messages="errors.collect('last_name')"
          :label="$t('label.last_name')"
          :data-vv-as="$t('label.last_name')"
          data-vv-name="last_name"
          required
        />
        <v-text-field
          v-model.trim="email"
          v-validate="validationRules.get('regex_email_without_polish')"
          class="required-field"
          :error-messages="errors.collect('regex_email_without_polish')"
          :label="$t('label.email')"
          data-vv-name="regex_email_without_polish"
          :data-vv-as="$t('label.email')"
          required
          inputmode="email"
        />
        <p class="mb-4">
          {{ $t('helps.help_phone') }}
        </p>
        <v-text-field
          v-model="phone_number"
          v-validate="validationRules.get('non_required_phone')"
          class="pt-0 mt-0"
          :mask="phoneMask(phone_number)"
          name="phone"
          :label="$t('label.phone')"
          data-vv-name="phone"
          :error-messages="errors.collect('phone')"
          :data-vv-as="$t('label.phone')"
          type="tel"
          inputmode="tel"
        />
        <v-autocomplete
          v-model="category"
          v-validate="validationRules.get('category')"
          class="required-field"
          :items="getReportersCategories"
          item-text="name"
          item-value="reporter_category_id"
          :label="$t('label.reporters_category')"
          :error-messages="errors.collect('category')"
          data-vv-name="category"
          :data-vv-as="$t('label.reporters_category')"
          required
          append-icon="expand_more"
          cache-items
          :search-input="search"
          :loading="getReportersCategories.length <= 0"
        />
        <FamilyReporterCorporation v-if="showCorporationFields" />
        <CRZConsents
          v-if="category != null"
          :JSONFileName="JSONFileName"
          @selectedConsents="setConsents($event)"
        />
        <v-layout
          v-if="isFormValid === false"
          mb-0
          mt-3
        >
          <v-flex>
            <div class="v-message text-xs-center">
              <div class="v-messages__message">
                {{ $t('errors.form_not_valid') }}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </form>
    </v-flex>
  </v-layout>
</template>

<script>
import validationRules from '@/constants/validationRules';

import CRZConsents from '@/components/widgets/CRZConsents';
import phoneMask from '@/utils/phoneMask';

import { mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';

import isArray from 'lodash.isarray';

import FamilyReporterCorporation from '@/components/addFamily/external/FamilyReporterCorporation';
import scrollToTopErrorMessage from '@/mixins/scrollToTopErrorMessage';
import { REPORTER_CATEGORIES } from '@/constants/reporterCategories';
import { DEFAULT_CONSENT_TYPE } from '@/constants/JSONFileName';
export default {
    name: 'FamilyReporter',
    components: { FamilyReporterCorporation, CRZConsents },
    mixins: [scrollToTopErrorMessage],
    data () {
        return {
            validationRules,
            isFormValid: true,
            search: null,
            phoneMask,
            consentDetails: false,
            termsAndConditions: null,
            mailConsent: null,
            isDisabled: false,
            DEFAULT_CONSENT_TYPE
        };
    },
    computed: {
        header () {
            return {
                title: this.$t('add_family.page_title'),
                subtitle: this.$t('outside_family.header_subtitles.person_data')
            };
        },
        ...mapFields('reporterData', [
            'reporterFormData.first_name',
            'reporterFormData.last_name',
            'reporterFormData.email',
            'reporterFormData.phone_number',
            'reporterFormData.consents',
            'reporterFormData.category'
        ]),
        ...mapGetters('defaultApi', ['getReportersCategories']),
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        chosenCategoryResource () {
            return this.getReportersCategories.find((category) => category?.reporter_category_id === this.category);
        },
        JSONFileName () {
            if (!isArray(this.getReportersCategories)) return DEFAULT_CONSENT_TYPE;
            return this.chosenCategoryResource?.consent_type ?? DEFAULT_CONSENT_TYPE;
        },
        showCorporationFields () {
            const consentTypeCurrentCategory = this.chosenCategoryResource?.consent_type;
            const CONSENT_TYPES_TO_SHOW_FIELDS = new Set([REPORTER_CATEGORIES.corporation, REPORTER_CATEGORIES.welfare]);
            return CONSENT_TYPES_TO_SHOW_FIELDS.has(consentTypeCurrentCategory);
        }
    },
    created () {
        this.$store.dispatch('defaultApi/getReportersCategories');
        this.$store.dispatch('provinces/getProvinces');
    },
    methods: {
        setConsents (event) {
            this.consents = event;
        },
        submit () {
            this.$validator.validateAll().then((result) => {
                this.isFormValid = result;
                if (result) {
                    this.$router.push({ name: 'family-consent-external' });
                } else {
                    this.scrollToTopErrorMessage();
                }
            });
        }
    }
};
</script>

<style scoped></style>
